import script from "./VersionChecker.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionChecker.vue?vue&type=script&setup=true&lang=js"

import "./VersionChecker.vue?vue&type=style&index=0&id=769fa4aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769fa4aa"]])

export default __exports__